import React, { Fragment, PureComponent } from 'react'
import { throttle } from 'lodash'

type Props = {
  buffer?: number
  children: React.ReactNode
}

export default class ExperimentVisible extends PureComponent<Props> {
  override state = {
    inViewport: false,
  }

  container = React.createRef<HTMLDivElement>()

  override componentDidMount = () => {
    this.bind()
  }

  override componentWillUnmount() {
    this.unbind()
  }

  bind = () => {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll() // component may be in view already
  }

  unbind = () => {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = throttle(() => {
    const { inViewport } = this.state

    if (!inViewport && this.isInViewport()) {
      this.setState({ inViewport: true })
      this.unbind()
    }
  }, 100)

  isInViewport = () => {
    if (!this.container.current) return false

    const { buffer } = this.props
    const { top } = this.container.current.getBoundingClientRect()

    return top >= 0 && top - (buffer ?? 0) <= window.innerHeight
  }

  override render() {
    const { inViewport } = this.state

    return (
      <Fragment>
        {!inViewport && <div ref={this.container} />}
        {inViewport && this.props.children}
      </Fragment>
    )
  }
}
